import script from './component-lib.esm9.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', _vm._g(_vm._b({
    ref: "products",
    staticClass: "v-products",
    class: _vm.classes
  }, 'div', _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-02be0ff8_0", {
    source: ".v-products[data-v-02be0ff8]{display:grid;gap:1rem;grid-template-columns:repeat(auto-fill,minmax(200px,1fr))}.v-products--scroll[data-v-02be0ff8]{display:flex;overflow:auto;padding-bottom:1rem}.v-products--scroll[data-v-02be0ff8]::-webkit-scrollbar{height:4px;background:0 0}.v-products--scroll[data-v-02be0ff8]::-webkit-scrollbar-thumb:horizontal{background:var(--g-color-gray-200)}.v-products--scroll[data-v-02be0ff8] .v-product{flex:1 0 200px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-02be0ff8";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var VProducts = __vue_component__;
export { VProducts as default };